import { render } from "./WineTourTineTightseven.vue?vue&type=template&id=4f04ec13"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/WineTourTineTightseven.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f04ec13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f04ec13', __exports__)) {
    api.reload('4f04ec13', __exports__)
  }
  
  module.hot.accept("./WineTourTineTightseven.vue?vue&type=template&id=4f04ec13", () => {
    api.rerender('4f04ec13', render)
  })

}


export default __exports__